import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_open",
  "use": "micro_open-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_open\"><path fill-rule=\"evenodd\" d=\"M7.293 2H3.5a.5.5 0 1 1 0-1h5a.498.498 0 0 1 .5.5v5a.5.5 0 1 1-1 0V2.707L1.854 8.854a.5.5 0 0 1-.708-.708L7.293 2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol